(function () {
  'use strict';

  function init(root) {
    if (root.dataset.afOrderReady === 'true') return;
    root.dataset.afOrderReady = 'true';
    var builder = root.querySelector('[data-af-order-builder]');
    var open = root.querySelector('[data-af-order-open]');
    if (!builder || !open) return;
    var panel = builder.querySelector('.af-order-builder__panel');

    function show() {
      builder.hidden = false;
      builder.setAttribute('aria-hidden', 'false');
      document.body.classList.add('af-order-builder-open');
      window.requestAnimationFrame(function () {
        builder.classList.add('is-open');
        var first = panel && panel.querySelector('button, input, select, a');
        if (first) first.focus();
      });
    }

    function hide() {
      builder.classList.remove('is-open');
      builder.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('af-order-builder-open');
      window.setTimeout(function () { builder.hidden = true; }, 180);
      open.focus();
    }

    function orderDetails() {
      var details = [];
      var title = document.querySelector('.product__title');
      details.push('Product: ' + (title ? title.textContent.trim() : document.title));
      var checked = root.querySelector('[data-product-options] input[type="radio"]:checked');
      if (checked) details.push('Selected option: ' + checked.value);
      var sizes = [];
      root.querySelectorAll('[data-size-qty]').forEach(function (input) {
        var qty = parseInt(input.value, 10) || 0;
        if (qty > 0) sizes.push(input.dataset.sizeValue + ' × ' + qty);
      });
      if (sizes.length) details.push('Quantities: ' + sizes.join(', '));
      var logo = root.querySelector('input[name="properties[Logo option]"]:checked');
      if (logo) details.push('Logo: ' + logo.value);
      var placement = root.querySelector('select[name="properties[Logo placement]"]');
      if (placement) details.push('Placement: ' + placement.value);
      var total = root.querySelector('[data-summary-total-big], [data-summary-total]');
      if (total) details.push('Estimated product total: ' + total.textContent.trim());
      return details.join('\n');
    }

    function proofUrl(link) {
      var details = orderDetails();
      try { window.sessionStorage.setItem('afProofRequestDetails', details); } catch (_e) {}
      var url = new URL(link.getAttribute('href') || '/pages/project', window.location.origin);
      url.searchParams.set('source', 'product-page');
      url.searchParams.set('product', document.title.replace(/\s*[|–-].*$/, '').trim());
      url.searchParams.set('order_details', details);
      url.searchParams.set('product_order_detail', details);
      return url.pathname + url.search;
    }

    open.addEventListener('click', show);
    builder.querySelectorAll('[data-af-order-close]').forEach(function (button) {
      button.addEventListener('click', hide);
    });
    root.querySelectorAll('[data-af-proof-request]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        window.location.href = proofUrl(link);
      });
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !builder.hidden) hide();
    });
  }

  function boot() {
    document.querySelectorAll('product-form.product__form__wrapper').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
